module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hrms15e-detail1Desc1"
    }
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "detail-header"
  }, [_c('h4', [_c('u', [_vm._v(_vm._s(_vm.labels['HRAP31EC32']['90']))])])]), _vm._v(" "), _c('hrms-table', {
    attrs: {
      "columns": _vm.detail1Desc1Table,
      "data": _vm.detail,
      "addInlineEventBool": _vm.validateStaappr,
      "editInlineEventBool": true,
      "deleteInlineEventBool": true,
      "deleteInlineBtnDisp": false,
      "saveInlineEvent": _vm.callSave,
      "saveInlineBtnDisp": _vm.validateStaappr,
      "columnEvent": _vm.columnEvent
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6a00ad15!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms15e/detail1Desc1.vue
// module id = 3833
// module chunks = 1